<template>
	<v-dialog
	  v-model="dialogLocal"
	  max-width="1200"
	  @click:outside="dialogLocal = false"
	  @keydown="dialogLocal = false"
	>
	  <v-card>
		<v-card-title class="py-3">
		  <h3>Mapeamento</h3>
		</v-card-title>
		<v-divider />
		<v-card-text>
			<v-row>
				<v-col cols="12">
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<td>COLUNA x CAMPO</td>
									<td>Tipo</td>
									<td>Formato</td>
									<td>Mascara</td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, key) in items">
									<td>
										<span class="d-inline-flex">{{ item.coluna_arquivo.toUpperCase() + ' x ' + item.campo_sistema_descricao.toUpperCase()}} </span>
									</td>
									<td>
										<span class="d-inline-flex">{{ item.coluna_arquivo_tipo_dados.toUpperCase()}}</span>
									</td>
									<td>
										<span class="d-inline-flex">{{ item.coluna_arquivo_formato_dados}} </span>
									</td>
									<td>
										<span v-if="getMascara(item).nomeMascara" class="d-inline-flex">
											{{ getMascara(item).nomeMascara.toUpperCase() +': '+ getMascara(item).parametro}}
										</span>
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</v-col>
			</v-row> 
		</v-card-text>
		<v-divider />
		<v-card-actions style="text-align:right !important; display: block !important">
		  <v-btn
			color="green darken-1"
			@click="dialogLocal = false"
		  >
			OK
		  </v-btn>
		</v-card-actions>
	  </v-card>
	</v-dialog>
  </template>
  
  <script>

	import PreImportacoesDadosService from "@/services/PreImportacoesDadosService.js"


  export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			preImpo: {
				type: Object,
			}
		},

		data: () => ({
			items: [],
		}),

		watch:{
			preImpo(newValue, oldValue){
				if(newValue && newValue.id && newValue != oldValue){
					this.items = []
					PreImportacoesDadosService.getMapeamentoPreImpo(this.preImpo.id)
					.then((resp) => {
						this.items = JSON.parse(resp.data.mapeamento)
					})
					.catch((err) => { 
						this.$toast.error(`Erro ao buscar mapeamento.`, '', {position: 'topRight'})
					});
				}
			},
		},
		
		computed: {
			dialogLocal: {
				get() {
					return this.dialog;
				},
				set(newValue) {
					this.$emit('update:dialog', newValue);
				}
			},
		},

		methods: {
			getMascara(item) {
				return item.mascara || item[0] || { nomeMascara: '', parametro: '' };
			}
		}
	}
</script>
